import React from "react"
import IconSkeleton from "./IconSkeleton"
import { IconProps } from "./types"
import { useTheme } from "../ThemeProvider"

export default function EnterprisePlanIcon(props: IconProps) {
  const theme = useTheme()

  return (
    <IconSkeleton {...props} iconName="EnterprisePlanIcon" stroke="none">
      <path
        d="M21.1576 6.82012C21.381 7.20708 21.4283 7.72569 21.2402 8.38837C21.0516 9.05312 20.636 9.8202 20.0022 10.6411C18.7361 12.281 16.6626 14.0536 14.0748 15.5477C11.4869 17.0418 8.91507 17.9511 6.86189 18.2277C5.83402 18.3662 4.96194 18.3425 4.29194 18.1735C3.62401 18.005 3.19851 17.7047 2.9751 17.3178C2.75169 16.9308 2.70443 16.4122 2.89248 15.7495C3.08111 15.0848 3.49665 14.3177 4.13049 13.4968C5.39658 11.857 7.47006 10.0843 10.0579 8.59024C12.6458 7.09615 15.2176 6.18677 17.2708 5.91021C18.2987 5.77176 19.1708 5.79542 19.8408 5.96444C20.5087 6.13293 20.9342 6.43316 21.1576 6.82012Z"
        stroke={theme.colors.purple[40]}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.0735 17.2049C20.8501 17.5918 20.4246 17.8921 19.7566 18.0606C19.0866 18.2296 18.2146 18.2532 17.1867 18.1148C15.1335 17.8382 12.5616 16.9289 9.97379 15.4348C7.38594 13.9407 5.31246 12.1681 4.04636 10.5282C3.41253 9.70729 2.99698 8.94021 2.80835 8.27547C2.62031 7.61279 2.66757 7.09417 2.89098 6.70722C3.11439 6.32026 3.53989 6.02002 4.20781 5.85153C4.87781 5.68252 5.74989 5.65885 6.77776 5.7973C8.83094 6.07386 11.4028 6.98324 13.9907 8.47734C16.5785 9.97143 18.652 11.744 19.9181 13.3839C20.5519 14.2048 20.9675 14.9719 21.1561 15.6366C21.3441 16.2993 21.2969 16.8179 21.0735 17.2049Z"
        stroke={theme.colors.purple[40]}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0663 1.82129C12.4247 1.82129 12.8368 1.99499 13.2864 2.45802C13.7383 2.92336 14.1798 3.63584 14.5665 4.57737C15.3384 6.45685 15.8332 9.10513 15.8332 12.069C15.8332 15.0328 15.3384 17.6811 14.5665 19.5605C14.1798 20.5021 13.7383 21.2146 13.2864 21.6799C12.8368 22.1429 12.4247 22.3166 12.0663 22.3166C11.7079 22.3166 11.2959 22.1429 10.8462 21.6799C10.3944 21.2146 9.95289 20.5021 9.5662 19.5605C8.79427 17.6811 8.29947 15.0328 8.29947 12.069C8.29947 9.10513 8.79427 6.45685 9.56619 4.57737C9.95289 3.63584 10.3944 2.92337 10.8462 2.45802C11.2959 1.99499 11.7079 1.82129 12.0663 1.82129Z"
        stroke={theme.colors.purple[40]}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="12" r="2" fill={theme.colors.purple[30]} />
      <circle cx="12.0001" cy="7.5" r="1" fill={theme.colors.green[50]} />
      <circle
        cx="5"
        cy="12"
        r="1"
        transform="rotate(-90 5 12)"
        fill={theme.colors.yellow[50]}
      />
      <circle cx="12.0001" cy="16.5" r="1" fill={theme.colors.orange[50]} />
      <circle
        cx="19"
        cy="12"
        r="1"
        transform="rotate(-90 19 12)"
        fill={theme.colors.teal[50]}
      />
      <circle
        r="10"
        transform="matrix(1 0 0 -1 12 12)"
        stroke={theme.colors.purple[40]}
      />
    </IconSkeleton>
  )
}
